<div class="pm-modal och-r" [formGroup]="form">

  <div class="pm-head">
    <h2 class="hd">Choose Your New Plan</h2>
    <button type="button" class="pm-x" (click)="close()" aria-label="Close">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
    </button>
  </div>

  <div class="pm-body">

    @if (activateTrial()) {
      <div class="pm-banner">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 16v-4M12 8h.01"/></svg>
        Activate your free 30-day trial
      </div>
    } @else {
      <p class="pm-note">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 16v-4M12 8h.01"/></svg>
        Your current plan is the <b>{{currentInstructorFrequencyDescription()}} {{currentInstructorPlan()?.name}}</b>.
      </p>
    }

    <p class="pm-cmp">Compare the features of each plan on the
      <a tabindex="-1" target="_blank" href="https://onlinecoursehost.com/pricing.html">Pricing Page</a>.</p>

    <div class="pm-plans">
      <button type="button" class="pm-plan" [class.sel]="selectedPlan === 'basic'" (click)="selectPlan('basic')">
        <span class="pm-plan-left">
          <span class="pm-radio"><i></i></span>
          <span class="pm-plan-name">{{basic.name}}</span>
        </span>
        <span class="pm-plan-right">
          <span class="pm-mo">{{pricingDetails('basic').monthly.split('/')[0]}}<span>/month</span></span>
          @if (selectedFrequency === 'yearly') {
            <span class="pm-bill">{{pricingDetails('basic').yearly.split(' ')[0]}} {{pricingDetails('basic').yearly.split(' ').splice(1).join(' ')}}</span>
          } @else {
            <span class="pm-bill">billed monthly</span>
          }
        </span>
      </button>

      <button type="button" class="pm-plan" [class.sel]="selectedPlan === 'pro'" (click)="selectPlan('pro')">
        <span class="pm-plan-left">
          <span class="pm-radio"><i></i></span>
          <span class="pm-plan-name">{{pro.name}}</span>
        </span>
        <span class="pm-plan-right">
          <span class="pm-mo">{{pricingDetails('pro').monthly.split('/')[0]}}<span>/month</span></span>
          @if (selectedFrequency === 'yearly') {
            <span class="pm-bill">{{pricingDetails('pro').yearly.split(' ')[0]}} {{pricingDetails('pro').yearly.split(' ').splice(1).join(' ')}}</span>
          } @else {
            <span class="pm-bill">billed monthly</span>
          }
        </span>
      </button>

      <button type="button" class="pm-plan" [class.sel]="selectedPlan === 'unlimited'" (click)="selectPlan('unlimited')">
        <span class="pm-plan-left">
          <span class="pm-radio"><i></i></span>
          <span class="pm-plan-name">{{unlimited.name}}</span>
        </span>
        <span class="pm-plan-right">
          <span class="pm-mo">{{pricingDetails('unlimited').monthly.split('/')[0]}}<span>/month</span></span>
          @if (selectedFrequency === 'yearly') {
            <span class="pm-bill">{{pricingDetails('unlimited').yearly.split(' ')[0]}} {{pricingDetails('unlimited').yearly.split(' ').splice(1).join(' ')}}</span>
          } @else {
            <span class="pm-bill">billed monthly</span>
          }
        </span>
      </button>
    </div>

    <div class="pm-billing">
      <div class="pm-bill-save"><b>Save 20%</b> with yearly billing</div>
      <div class="pm-bill-opts">
        <button type="button" class="pm-bill-opt" [class.on]="selectedFrequency === 'yearly'" (click)="selectFrequency('yearly')">
          <span class="pm-radio sm"><i></i></span> Pay Yearly
        </button>
        <button type="button" class="pm-bill-opt" [class.on]="selectedFrequency === 'monthly'" (click)="selectFrequency('monthly')">
          <span class="pm-radio sm"><i></i></span> Pay Monthly
        </button>
      </div>
    </div>

  </div>

  <div class="pm-foot">
    <button type="button" class="btn btn-ghost" (click)="close()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
      Close
    </button>
    <button type="button" class="btn btn-pri" (click)="changePlan()" [disabled]="!form.valid || isCurrentPlanSelected()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l7 3v5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3z"/></svg>
      Activate Plan
    </button>
  </div>

</div>
